import {
AfterViewInit,Component,
ElementRef,
Inject,
OnDestroy,
OnInit,
ViewChild
} from '@angular/core';
import { FormArray,FormControl,FormGroup,UntypedFormControl,Validators } from '@angular/forms';
import { MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { MatLegacyDialog as MatDialog,MatLegacyDialogConfig as MatDialogConfig,MatLegacyDialogRef as MatDialogRef,MatLegacyDialogState as MatDialogState,MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import moment,{ Moment } from 'moment';

import { BehaviorSubject,combineLatest,firstValueFrom,Observable,of, Subject,Subscription } from 'rxjs';
import {
distinctUntilChanged,
filter,
map,
shareReplay,
skip,
startWith,
switchMap,
take, takeUntil,
tap,
withLatestFrom
} from 'rxjs/operators';
import { ConstructionDiaryEntity,ConstructionDiaryEntityAdditionalData,ConstructionDiaryStatusEnum } from '../../../../dave-data-module/entities/construction-diary.entity';
import { AdditionalDataEvent,EventEntity,EventStateEnum,EventStateEnumColorMap,EventStateEnumNameMap,MapMarker,MapMarkerFileDictionary } from '../../../../dave-data-module/entities/event.entity';
import { FileEntity } from '../../../../dave-data-module/entities/file.entity';
import { FolderEntity,FolderTypes } from '../../../../dave-data-module/entities/folder.entity';
import { UserToEventEntity,UserToEventEntityAdditionalData } from '../../../../dave-data-module/entities/user-to-event.entity';
import { State } from '../../../../dave-data-module/State';
import { BaseActionTypes } from '../../../../dave-data-module/State/actions/base.actions';
import { EventsActionTypes } from '../../../../dave-data-module/State/actions/events.actions';
import { FilesActionTypes,FileUploadParams } from '../../../../dave-data-module/State/actions/files.actions';
import { UserToEventActionTypes } from '../../../../dave-data-module/State/actions/user-to-event.action';
import { getToken } from '../../../../dave-data-module/State/selectors/base.selectors';
//import { getConstructionDiaries } from '../../../../dave-data-module/State/selectors/construction-diary.selectors';
import { getEventById } from '../../../../dave-data-module/State/selectors/events.selectors';
import { getFiles } from '../../../../dave-data-module/State/selectors/files.selectors';
import { getUserToEventFetched,getUserToEvents } from '../../../../dave-data-module/State/selectors/user-to-event.selector';
import { getUsersFetched,getUsersWithMyPartnerId } from '../../../../dave-data-module/State/selectors/users.selectors';

import { formatDate } from '@angular/common';
import { isArray } from 'chart.js/helpers';
import { DropzoneComponent,DropzoneConfig } from 'ngx-dropzone-wrapper';
import { ToastrService } from 'ngx-toastr';
import { EntityTypesEnum } from 'src/app/dave-data-module/entities/entity-role.entity';
import { UserResolver } from 'src/app/dave-data-module/guards/user.resolver';
import { getEntityRole,getEntityRoleFetched } from 'src/app/dave-data-module/State/selectors/entity-role.selector';
import { AppConfirmationDialogComponent,AppConfirmationDialogData } from 'src/app/dave-utils-module/app-dialog-module/app-confirmation-dialog/app-confirmation-dialog.component';
import { FilterOption,FILTER_TYPE_BOOLEAN,FILTER_TYPE_SEARCH_MULTI_SELECT,IFilterTypeSearchMultiSelectValue } from 'src/app/dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { FilterTypes } from 'src/app/services/default-filter.service';
import { EventCategoriesEntity } from '../../../../dave-data-module/entities/event-categories.entity';
import { EventTypeEntity,EventTypeNamesEnum } from '../../../../dave-data-module/entities/event-type.entity';
import { PersonEntity } from '../../../../dave-data-module/entities/person.entity';
import { DaveMutationCreateConstructionDiaryArgs } from '../../../../dave-data-module/graphql-types';
import { PersonResolver } from '../../../../dave-data-module/guards/person.resolver';
import { Person2EntityResolver } from '../../../../dave-data-module/guards/person2Entity.resolver';
import { UserToCommissionResolver } from '../../../../dave-data-module/guards/user-to-commission.resolver';
import { UserToEventResolver } from '../../../../dave-data-module/guards/user-to-event.resolver';
import { FrontendDate } from '../../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../../../dave-data-module/helper/helper';
import { ConstructionDiaryDataService } from '../../../../dave-data-module/services/construction-diary-data.service';
import {
CategoriesWithAssignments,
EventCategoriesDataService
} from '../../../../dave-data-module/services/event-categories.service-data-service';
import { FileDataService } from '../../../../dave-data-module/services/file-data.service';
import { FolderDataService } from '../../../../dave-data-module/services/folder-data.service';
import { HttpService } from '../../../../dave-data-module/services/http.service';
import { ConstructionDiaryActionTypes } from '../../../../dave-data-module/State/actions/construction-diary.actions';
import { EventCategoriesActionTypes } from '../../../../dave-data-module/State/actions/event-categories.actions';
import { getCommissionById } from '../../../../dave-data-module/State/selectors/commission.selector';
import { getCommissionTypeById } from '../../../../dave-data-module/State/selectors/commissionType.selectors';
import {
selectEventCategories,
selectEventCategoriesFetched
} from '../../../../dave-data-module/State/selectors/event-Categories.selector';
import { getEventTypeById } from '../../../../dave-data-module/State/selectors/event-type.selector';
import { getPartner } from '../../../../dave-data-module/State/selectors/partners.selectors';
import { getPersonDictionary,getPersonsFetched } from '../../../../dave-data-module/State/selectors/person.selectors';
import { getPerson2EntitiesFetched,getPerson2EntityByCommissionId } from '../../../../dave-data-module/State/selectors/person2entity.selectors';
import { getUserToCommissionByCommissionId,getUserToCommissionFetched } from '../../../../dave-data-module/State/selectors/user-to-commission.selector';
import { PdfEditorLegacyComponent } from '../../../../dave-dms-module/dave-dms/pdf-editor-legacy/components/pdf-editor-legacy.component';
import { SelectPersonsComponent,SelectPersonsComponentDialogData,SelectPersonsComponentDialogReturnData } from '../../../../dave-person-module/components/select-persons/select-persons.component';
import {
DaveSelectFileFromDmsComponent,
DaveSelectFileFromDmsComponentDialogData,
DaveSelectFileFromDmsComponentReturnData
} from '../../../../dave-select-file-from-dms/components/dave-select-file-from-dms/dave-select-file-from-dms.component';
import { AppDialogService } from '../../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { SelectSearchData } from '../../../../dave-utils-module/select-search/components/select-search-legacy/select-search-legacy.component';
import { appMatDialogDefaultConfig,isNotNullOrUndefined,PLAN_FILE_PREFIX_FOR_SFDT_TEMPLATES,sameDay,uniqArray } from '../../../../helper/helper';
import { DMSPageMeta } from '../../../../helper/page-metadata';
import { getErrorMessage, userToEventTimespanValidator } from '../../../../helper/validation.helper';
import { LoadingService } from '../../../../services/loading.service';
import { ConstructionDiaryMaterialDeviceListComponent,createMaterialDeviceForm,materialDeviceForm } from '../detail-construction-diary-entry/construction-diary-material-device-list/construction-diary-material-device-list.component';
import { ConstructionDiaryPlansComponent } from '../detail-construction-diary-entry/construction-diary-plans/construction-diary-plans.component';
import {
InterruptionEventsListCardComponent
} from '../interruption-events-list-card/interruption-events-list-card.component';
import {
    getConstructionDiariesByCommissionId
} from '../../../../dave-data-module/State/selectors/construction-diary.selectors';
import { EventDataService } from '../../../../dave-data-module/services/event.service-data-service';
import { UserToCommissionEntity } from '../../../../dave-data-module/entities/user-to-commission.entity';

export interface AppAddEventDialogData {
    eventId?: number;
    eventTypeId?: number;
    headline?: string;
    hideDate?: boolean;
    canDelete?: boolean;
    categories?: CategoriesWithAssignments;
    diary?: ConstructionDiaryEntity;
    commissionId?: number;
    newEvent?: boolean;
}

interface TableData {
    name: string;
    timeForm: FormControlTyped<string>;
    u2e: UserToEventEntity;
}



export type AppAddEventDialogDataReturn = 'save' | 'abort';

@Component({
    selector: 'app-add-event-dialog',
    templateUrl: './add-event-dialog.component.html',
    styleUrls: ['./add-event-dialog.component.scss'],
})
export class AddEventDialogComponent implements OnInit, OnDestroy, AfterViewInit {
    // @ViewChild('appPdfEditor') pdfEditor: PdfEditorComponent;
    @ViewChild('plansComponent') plansComponent: ConstructionDiaryPlansComponent;
    @ViewChild('constructiondiarymaterialdevicelist') constructiondiarymaterialdevicelist: ConstructionDiaryMaterialDeviceListComponent;
    @ViewChild('dropzoneComp') dropzoneComponent!: DropzoneComponent;
    @ViewChild(InterruptionEventsListCardComponent) interruptionEventsListCardComponent!: InterruptionEventsListCardComponent;
    afterViewInit$ = new BehaviorSubject<boolean>(false);
    // @ViewChild('leafletMap') leafletMap: LeafletWrapperComponent;
    public static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '50vw',
        width: '100rem',
        maxWidth: '96vw',
        maxHeight: '96vh',
        height: '80rem',
        minHeight: '80vh',
        closeOnNavigation: false,
        autoFocus: false,
    };
    // private mapMarkerBuffer: {
    //     [key: number]: {
    //         _latlng: {
    //             lat: number;
    //             lng: number;
    //         };
    //     }[];
    // } = {};
    public planFiles$: Observable<Array<FileEntity>>;
    public plans$: Observable<Array<{ documentId: number; documentName: string; optionLabel: string; imageUrl: string }>>;
    protected assignedPersons$: Observable<PersonEntity[]>;
    public DMSNotMinimalistic = false;
    private fileDialog: MatDialogRef<any>;
    private eventId$ = new BehaviorSubject<number | null>(null);
    public Event$: Observable<EventEntity> = this.eventId$.pipe(
        filter(isNotNullOrUndefined),
        distinctUntilChanged(),
        switchMap((id) => this.eventData.GetSingleEvent$(id)),
        filter(isNotNullOrUndefined),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected mapMarker$: Observable<MapMarkerFileDictionary>;
    protected defaultMarker$: Observable<Pick<MapMarker, 'color' | 'tooltip'>>;
    protected options$: Observable<EventCategoriesEntity[]>;
    public EventType$: Observable<EventTypeEntity>;
    public Diary$: Observable<ConstructionDiaryEntity>;
    public Folder$: Observable<FolderEntity>;
    public DMSMeta = DMSPageMeta;
    public DropzoneConfig$: Observable<DropzoneConfig>;
    protected isSteinhoff$ = this.store.select(getPartner).pipe(
        map((partner) => partner.Id === window['env']['steinhoff_partner_id']),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected showExecutingCompany$ = this.isSteinhoff$;
    private fileUploadParams$: Observable<FileUploadParams>;
    private commissionEntityRoles$ = getFetched$(this.store, getEntityRoleFetched, getEntityRole).pipe(map((roles) => roles.filter((r) => r.Entity === EntityTypesEnum.Commission)));
    private SaveNextEvent = false;
    /** blockiert den Dialog per Overlay, bis das nächste Event angelegt ist */
    protected SavingNext = false;

    public FilterValues$: BehaviorSubject<{
        [FilterTypes.Roles]: IFilterTypeSearchMultiSelectValue<number>[];
        [FilterTypes.HideAssignee]: boolean;
    }> = new BehaviorSubject({
        [FilterTypes.Roles]: [],
        [FilterTypes.HideAssignee]: false,
    });
    public FilterSettings$: Observable<FilterOption[]> = this.commissionEntityRoles$.pipe(
        map((roles) => {
            return [
                {
                    Name: FilterTypes.Roles,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Rolle',
                    Icon: null,
                    Values: roles.map<IFilterTypeSearchMultiSelectValue>((t) => ({ id: t.Id, label: t.DisplayName })),
                },
                {
                    Name: FilterTypes.HideAssignee,
                    Type: FILTER_TYPE_BOOLEAN,
                    Label: 'Verantwortliche ausblenden',
                },
            ];
        }),
    );
    public FilterAmount$ = this.FilterValues$.pipe(
        map((filterValues) => {
            let filterAmount = 0;
            for (const [key, value] of Object.entries(filterValues)) {
                if (isArray(value) && value?.length) {
                    filterAmount++;
                }
                if (key === FilterTypes.HideAssignee && value) {
                    filterAmount++;
                }
            }
            return filterAmount > 0 ? filterAmount : undefined;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private destroy$ = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) public Data: AppAddEventDialogData,
        u2eResolver: UserToEventResolver,
        userResolver: UserResolver,
        private dialog: MatDialog,
        private store: Store<State>,
        private dialogRef: MatDialogRef<AddEventDialogComponent>,
        private actions$: Actions,
        public LS: LoadingService,
        private fileDataService: FileDataService,
        private constructionDiaryDataService: ConstructionDiaryDataService,
        private api: HttpService,
        private folderDataService: FolderDataService,
        u2cResolver: UserToCommissionResolver,
        private toastrService: ToastrService,
        private personResolver: PersonResolver,
        private personToEntityResolver: Person2EntityResolver,
        private eventCategoriesDataService: EventCategoriesDataService,
        private appDialog: AppDialogService,
        private eventData: EventDataService,
    ) {
        firstValueFrom(this.store.select(getUsersFetched)).then((fetched) => {
            if (!fetched) {
                userResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getUserToEventFetched)).then((fetched) => {
            if (!fetched) {
                u2eResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getUserToCommissionFetched)).then((fetched) => {
            if (!fetched) {
                u2cResolver.resolve();
            }
        });
    }

    private categoryIdsRemoved: number[] = [];
    private categoryIdsAdded: number[] = [];
    private fileUploadUIds = [];
    EventStateOptions = Array.from(EventStateEnumNameMap.keys()).map((k) => ({ label: EventStateEnumNameMap.get(k), value: k }));
    public DialogFormGroup = new FormGroup({
        eventName: new FormControl<string | null>(null),
        eventText: new FormControl<string | null>(null),
        state: new FormControl<EventStateEnum>(EventStateEnum.New, Validators.required),
        date: new FormControl<Moment | null>(moment()),
        mapMarker: new FormControl<MapMarkerFileDictionary>(null),
        executingCompany: new FormControl<string>(''),
        MaterialDevices: new FormArray<materialDeviceForm>([]),
        Categories: new FormControl<EventCategoriesEntity[] | null>(null),
        eventNumber: new FormControl<string | null>(null),
        automaticEventNumber: new FormControl<boolean>(false),
    });
    public NewUserToEventFormGroup = new FormGroup({
        user: new FormControl<SelectSearchData>(null, Validators.required),
        time: new FormControl<string>(null, [Validators.required, userToEventTimespanValidator()]),
    });
    public getErrorMessage = getErrorMessage;
    public Diaries: ConstructionDiaryEntity[];
    public Users$ = this.store.select(getUsersWithMyPartnerId).pipe(
        map((u) => u?.filter((us) => !us.Deleted)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public UsersForSelectSearch$: Observable<{ Id: number; Name: string; SearchContent: string; optionLabel: string }[]>;
    private subs: Subscription[] = [];
    public UserToEvents$: Observable<TableData[]>;
    DateClass = (d: Moment): MatCalendarCellCssClasses => {
        const date = d.toDate();
        const diary = this.Diaries.find((d) => sameDay(d.Date, date));
        return diary?.GeneratedFileId ? 'blue' : diary?.Status === ConstructionDiaryStatusEnum.Newly ? 'yellow' : diary?.Status === ConstructionDiaryStatusEnum.Done ? 'green' : '';
    };

    private previousCategories: EventCategoriesEntity[] = [];
    ngOnDestroy(): void {
        this.subs.forEach((s) => s.unsubscribe());
        this.afterViewInit$.complete();

        this.destroy$.next();
        this.destroy$.complete();

        this.fileDialog?.close();
    }
    compareById = (a, b) => a?.Id === b?.Id;

    async ngOnInit(u2es?: TableData[]): Promise<void> {
        if(this.Data?.eventId) {
            this.eventId$.next(this.Data.eventId);
        }
        if(!this.Data?.commissionId){
            this.Data.commissionId = await firstValueFrom(this.Event$).then((e) => e?.CommissionId);
        }

        if (!this.Data?.eventId) {
            this.store
                .select(getCommissionById({ id: this.Data.commissionId }))
                .pipe(filter(isNotNullOrUndefined), take(1))
                .subscribe((commission) =>
                    this.store.dispatch(
                        EventsActionTypes.AddEvent({
                            Payload: {
                                isTask: false,
                                eventTypeId: this.Data.eventTypeId,
                                commissionId: this.Data.commissionId,
                                customerId: commission.CustomerId,
                                eventDate: FrontendDate(this.Data?.diary ? this.Data.diary.Date : new Date()),
                                state: EventStateEnum.New,
                                automaticEventNumber: true,
                                // wenn kein name mitgeschickt wird generiert das Backend einen
                                // name: this.Data.headline + ' ' + formatDate(this.Data?.diary ? this.Data.diary.Date : new Date(), 'dd.MM.yyyy', 'de-DE'),
                            },
                        }),
                    ),
                );
            const action = await firstValueFrom(this.actions$.pipe(ofType(EventsActionTypes.UpdateEvent), take(1)));
            this.Data.eventId = action.Payload.Id;
            this.eventId$.next(this.Data.eventId);
            if(this.SaveNextEvent){
                this.Data.diary = await firstValueFrom(
                    this.store.select(getConstructionDiariesByCommissionId(this.Data.commissionId)).pipe(map((diaries) => diaries?.filter((d) => sameDay(d.Date, this.Data.diary?.Date)))))[0];
            }

            if (this.Data?.diary) {
                this.store.dispatch(
                    ConstructionDiaryActionTypes.Modify({
                        Payload: {
                            id: this.Data.diary.Id,
                            eventIds: this.Data.diary.EventIds ? [...this.Data.diary.EventIds, action.Payload.Id] : [action.Payload.Id],
                        },
                    }),
                );
            }

            if (this.SaveNextEvent) {
                if(u2es){
                    u2es.forEach(u2e => {
                         this.store.dispatch(
                            UserToEventActionTypes.Create({
                                Payload: {
                                    eventId: this.Data.eventId,
                                    userId: u2e.u2e.UserId,
                                    additionalData: JSON.stringify(u2e.u2e.AdditionalData),
                                },
                            }),
                        );
                    })
                }
                if (this.categoryIdsAdded.length > 0) {
                    for (const categoryId of this.categoryIdsAdded) {
                        await this.eventCategoriesDataService.addEvent2EventCategory({
                            EventId: this.Data.eventId.toString(),
                            CategoryId: categoryId.toString(),
                        });
                    }


                    this.categoryIdsAdded = [];
                    this.categoryIdsRemoved = [];
                }
            }
        }
        this.store
            .select(selectEventCategoriesFetched)
            .pipe(take(1))
            .subscribe(async (fetched) => {
                if (!fetched) {
                    this.store.dispatch(EventCategoriesActionTypes.Load({ Payload: {} }));
                    this.Data.categories = await this.eventCategoriesDataService.getRequest();
                } else {
                    this.Data.categories = await firstValueFrom(this.store.select(selectEventCategories));
                }
                if (this.Data.categories) {
                    this.options$ = of(this.Data.categories.EventCategories);
                    this.UserToEvents$ = combineLatest([
                        this.store.select(getUserToEvents).pipe(
                            filter(isNotNullOrUndefined),
                            map((u2es) => u2es.filter((u2e) => u2e.EventId === this.Data.eventId && u2e.AdditionalData !== null)),
                        ),
                        this.Users$,
                    ]).pipe(
                        map(([u2es, users]) => {
                            return u2es.map((u2e) => {
                                const timeForm = new FormControl<string>(u2e.AdditionalData?.timespan, [Validators.required, userToEventTimespanValidator()]);
                                return {
                                    name: users.find((u) => u.Id === u2e.UserId).DisplayName,
                                    timeForm,
                                    u2e,
                                };
                            });
                        }),
                    );
                    this.UsersForSelectSearch$ = combineLatest([
                        this.Users$,
                        this.Event$.pipe(
                            switchMap((e) => (e?.CommissionId ? getFetched$(this.store, getUserToCommissionFetched, getUserToCommissionByCommissionId({ commissionId: e.CommissionId })) : of([] as UserToCommissionEntity[])))
                        ),
                        this.FilterValues$,
                    ]).pipe(
                        map(([users, userToCommissions, filter]) =>
                            users
                                ?.filter((u) => {
                                    var u2cs = userToCommissions.filter((u2c) => u2c.UserId === u.Id);
                                    if (filter[FilterTypes.Roles]?.length) {
                                        u2cs = u2cs.filter((u2c) => filter[FilterTypes.Roles].some((f) => f.id === u2c.RoleId));
                                    }
                                    if (filter[FilterTypes.HideAssignee]) {
                                        u2cs = u2cs.filter((u2c) => !u2c.Assignee);
                                    }
                                    return u2cs.length;
                                })
                                .map((u) => ({
                                    Name: u.DisplayName,
                                    Id: u.Id,
                                    SearchContent: u.Email,
                                    optionLabel: u.DisplayName,
                                })),
                        ),
                    );
                    this.Diary$ = this.store.select(getConstructionDiariesByCommissionId(this.Data.commissionId)).pipe(map((diaries) => diaries?.find((d) => d.EventIds?.includes(this.Data.eventId))));
                    this.mapMarker$ = combineLatest([this.Event$, this.DialogFormGroup.controls.mapMarker.valueChanges.pipe(startWith(null))]).pipe(
                        map(([e, _]) => {
                            return this.DialogFormGroup.controls.mapMarker.value
                                ? Object.keys(this.DialogFormGroup.controls.mapMarker.value).reduce((prev, key) => {
                                      prev[key] = this.DialogFormGroup.controls.mapMarker.value[+key].map((m) => ({ ...m, color: e.State ? EventStateEnumColorMap.get(e.State) : undefined, tooltip: e.Id + '' }));
                                      return prev;
                                  }, {})
                                : {};
                        }),
                    );

                    this.defaultMarker$ = this.Event$.pipe(
                        map((e) => ({
                            color: e.State ? EventStateEnumColorMap.get(e.State) : undefined,
                            tooltip: e.Id + '',
                        })),
                    );
                    this.assignedPersons$ = this.Event$.pipe(
                        switchMap((event) =>
                            event.CommissionId
                                ? getFetched$(this.store, getPerson2EntitiesFetched, getPerson2EntityByCommissionId({ commissionId: event.CommissionId }), this.personToEntityResolver).pipe(
                                      switchMap((p2e) =>
                                          p2e.length
                                              ? getFetched$(this.store, getPersonsFetched, getPersonDictionary, this.personResolver).pipe(map((persons) => uniqArray(p2e.map((p) => p.PersonId)).map((personId) => persons[personId])))
                                              : of([]),
                                      ),
                                  )
                                : of([]),
                        ),
                        shareReplay({ bufferSize: 1, refCount: true }),
                    );
                    this.planFiles$ = this.Event$.pipe(
                        switchMap((event) => (event.CommissionId ? this.store.select(getCommissionById({ id: event.CommissionId })) : of(null))),
                        map((commission) => commission?.PlanIds),
                        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
                        switchMap((ids) => (ids.length ? this.fileDataService.GetFilesById(ids) : of([]))),
                        map((files) => files.filter(isNotNullOrUndefined)),
                        shareReplay({ refCount: true, bufferSize: 1 }),
                    );
                    this.plans$ = this.planFiles$.pipe(
                        withLatestFrom(this.store.select(getToken)),
                        map(([files, token]) => files.map((f) => ({ documentId: f.Id, documentName: f.Name, optionLabel: f.Name, imageUrl: this.api.GetUrl(f.GetLastVersion().GetDownloadLink(token), 'file') }))),
                        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
                        shareReplay({ refCount: true, bufferSize: 1 }),
                    );
                    // this.eventMapMarker$ = this.Event$.pipe(switchMap(e => this.MockPlan.pipe(map(p => e.AdditionalData?.mapMarker[p.Id]))));
                    this.EventType$ = this.Event$.pipe(switchMap((e) => this.store.select(getEventTypeById({ id: e.EventTypeId }))));
                    const diarysByCommission$ = this.Event$.pipe(
                        switchMap((event) =>
                            this.store.select(
                                getConstructionDiariesByCommissionId(event.CommissionId)
                            )
                        )
                    );
                    this.Folder$ = this.folderDataService.getFolderFromEntity(this.Data.eventId, FolderTypes.event).pipe(shareReplay({ refCount: true, bufferSize: 1 }));
                    this.subs.push(
                        this.Folder$.subscribe(),
                        diarysByCommission$.subscribe((diaries) => (this.Diaries = diaries)),
                        combineLatest([this.Event$, this.Diary$, this.afterViewInit$]).subscribe(([event, diary, viewInited]) => {
                            if (event && event.Id === this.Data.eventId) {
                                console.log(event);
                                const filteredCatIds = this.Data.categories.Event2EventCategories.filter((e2ec) => e2ec.EventId === event.Id);
                                const filteredCats = this.Data.categories.EventCategories.filter((cat) => filteredCatIds.some((e2ec) => e2ec.CategoryId === cat.Id));

                                console.log(event.AdditionalData);
                                if (!this.SaveNextEvent) {
                                    this.DialogFormGroup.controls.MaterialDevices.clear();
                                    const materialDevices = event.getMaterialDevicesEvent();
                                    materialDevices.forEach((device) => this.DialogFormGroup.controls.MaterialDevices.push(createMaterialDeviceForm(device)));

                                    this.DialogFormGroup.setValue(
                                        {
                                            eventName: event.Name || this.DialogFormGroup.value.eventName,
                                            eventText: event.Description,
                                            date: diary ? moment(diary.Date) : moment(event.EventDate),
                                            state: event.State,
                                            mapMarker: event.AdditionalData?.mapMarker || {},
                                            executingCompany: event.ExecutingCompany || '',
                                            MaterialDevices: materialDevices,
                                            Categories: filteredCats,
                                            eventNumber: event.EventNumber,
                                            automaticEventNumber: false,
                                        },
                                        { emitEvent: true },
                                    );
                                } else {
                                    const { eventName, eventNumber, automaticEventNumber, mapMarker, Categories } = this.DialogFormGroup.controls;
                                    if (eventName.pristine) {
                                        eventName.setValue(event.Name || eventName.value);
                                    }
                                    if (eventNumber.pristine && automaticEventNumber.pristine) {
                                        eventNumber.setValue(event.EventNumber);
                                        automaticEventNumber.setValue(false);
                                    }
                                    if (mapMarker.pristine) {
                                        mapMarker.setValue({});
                                    }
                                    if (Categories.pristine) {
                                        Categories.setValue(filteredCats);
                                    }
                                }
                                if (viewInited && event.AdditionalData?.mapMarker && Object.keys(event.AdditionalData.mapMarker)?.length) {
                                    firstValueFrom(this.plans$).then((plans) => {
                                        firstValueFrom(this.afterViewInit$.pipe(filter((v) => v))).then(() => {
                                            const pId = Object.keys(event.AdditionalData.mapMarker).find((k) => plans.some((p) => p.documentId.toString() === k));
                                            const p = plans.find((p) => p.documentId.toString() === pId);
                                            console.log({ plans, pId, p, keys: Object.keys(event.AdditionalData.mapMarker) });
                                            setTimeout(() => this.plansComponent.planForm.setValue(p), 10) ;
                                        });
                                    });
                                }
                            }
                        }),
                    );
                    this.fileUploadParams$ = combineLatest([this.Event$, this.Diary$]).pipe(
                        map(([event, diary]) => {
                            const p: FileUploadParams = new Map([
                                ['commission_id', JSON.stringify([event.CommissionId])],
                                ['event_id', JSON.stringify([this.Data.eventId])],
                                ['auto_set_folder', 'true'],
                            ]);
                            if (diary?.EventIds.includes(event.Id)) {
                                p.set('construction_diary', diary.Id.toString());
                            }
                            return p;
                        }),
                    );
                    this.DropzoneConfig$ = combineLatest([this.fileUploadParams$, this.store.select(getToken)]).pipe(
                        map(([paramsMap, token]) => {
                            const params = [];
                            paramsMap.forEach((value, key) => {
                                params[key] = value;
                            });
                            return new DropzoneConfig({
                                autoProcessQueue: true,
                                uploadMultiple: false,
                                paramName: () => 'file',
                                parallelUploads: 100,
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                },
                                params,
                            });
                        }),
                    );
                    this.previousCategories = this.DialogFormGroup.controls.Categories.value;
                    this.subs.push(
                        this.DialogFormGroup.controls.Categories.valueChanges.pipe(skip(1)).subscribe((categories) => {
                            this.onCategoriesChanged(categories);
                            this.previousCategories = this.DialogFormGroup.controls.Categories.value;
                        }),
                    );
                }
            });

        const { automaticEventNumber, eventNumber } = this.DialogFormGroup.controls;

        this.subs.push(
            automaticEventNumber.valueChanges.pipe(startWith(automaticEventNumber.value)).subscribe((automatic) => {
                if (automatic) {
                    eventNumber.setValue(null, { emitEvent: false });
                    eventNumber.disable({ emitEvent: false });
                } else {
                    eventNumber.enable({ emitEvent: false });
                }
            }),
        );

    }

    trackById(index: number, event: { Id: number }){
return event.Id;
    }

    public async Delete() {
        if (this.Data.canDelete) {
            const eventId = await firstValueFrom(this.Event$.pipe(map((e) => e.Id)));
            const eventName = await firstValueFrom(this.Event$.pipe(map((e) => e.Name)));
            this.dialog
                .open<AppConfirmationDialogComponent, AppConfirmationDialogData>(AppConfirmationDialogComponent, {
                    data: {
                        heading: 'Störung wirklich löschen?',
                        paragraph: 'Sind sie sicher, das Sie die Störung ' + eventName + ' löschen möchten?',
                        styleDelete: true,
                    },
                })
                .afterClosed()
                .pipe(
                    take(1),
                    filter(([response]) => response),
                    tap(() => this.store.dispatch(EventsActionTypes.DeleteEvent({ Payload: eventId }))),
                    tap(() => this.dialogRef.close()),
                )
                .subscribe();
        }
    }



    public async Save(multiple: boolean = false) {
        let u2esTabeledata: TableData[] = [];
        this.UserToEvents$.pipe(take(1)).subscribe((u2es) => {
             u2esTabeledata = u2es;
        });
        this.constructiondiarymaterialdevicelist?.pushPendingForm();
        this.LS.isLoading = true;
        this.SavingNext = multiple;


        this.store
            .select(getConstructionDiariesByCommissionId(this.Data.commissionId))
            .pipe(take(1), withLatestFrom(this.Diary$, this.Event$))
            .subscribe(([diaries, oldDiary, event]) => {
                if (!oldDiary || !sameDay(oldDiary.Date, this.DialogFormGroup.value.date.toDate())) {
                    if (oldDiary) {
                        this.store.dispatch(
                            ConstructionDiaryActionTypes.Modify({
                                Payload: {
                                    id: oldDiary.Id,
                                    eventIds: oldDiary.EventIds.filter((id) => id !== this.Data.eventId),
                                },
                            }),
                        );
                    }
                    const date = this.DialogFormGroup.value.date.toDate();
                    const newDiary = diaries.find((d) => d.CommissionId === event.CommissionId && sameDay(d.Date, date));
                    // todo create diary if not exists
                    if (newDiary) {
                        this.store.dispatch(
                            ConstructionDiaryActionTypes.Modify({
                                Payload: {
                                    id: newDiary.Id,
                                    eventIds: [...newDiary.EventIds, this.Data.eventId],
                                },
                            }),
                        );
                    } else {
                        firstValueFrom(this.store.select(getCommissionById({ id: event.CommissionId })).pipe(switchMap((c) => this.store.select(getCommissionTypeById({ id: c.CommissionTypeId }))))).then((commissionType) => {
                            const addData: ConstructionDiaryEntityAdditionalData = {
                                weather: { description: '', temp: null },
                                leistungsergebnisseTemplateIds: null,
                            };
                            const values: DaveMutationCreateConstructionDiaryArgs = {
                                leistungsergebnisse: '',
                                additionalData: JSON.stringify(addData),
                                leistungsaenderungen: '',
                                besondereVorkommnisse: '',
                                commissionId: event.CommissionId,
                                eventIds: [this.Data.eventId],
                            };
                            const dayliTodos = commissionType?.AdditionalData?.ConstructionDiary.dailyTodos || [];
                            const tasks: EventEntity[] = dayliTodos.map((dailyTodo) => {
                                const date = new Date(FrontendDate(this.DialogFormGroup.value.date?.toDate(), true));
                                date.setHours(dailyTodo.time.hour);
                                date.setMinutes(dailyTodo.time.minute);

                                return new EventEntity().Clone({
                                    Name: dailyTodo.name,
                                    State: EventStateEnum.New,
                                    AdditionalData: { ...dailyTodo.additionalData, UnicId: dailyTodo.unicId },
                                    EventDate: date,
                                });
                            });
                            this.constructionDiaryDataService.saveDiaryEntry({ Date: this.DialogFormGroup.value.date?.toDate() }, tasks, values, event.CommissionId);
                        });
                    }
                }
                let additionalEventData: AdditionalDataEvent = JSON.parse(JSON.stringify(event.AdditionalData || {}));

                const mapMarker = this.DialogFormGroup.value.mapMarker;

                /**
                 * jedes event darf nur noch auf einem plan einen marker haben
                 */
                const m = /*additionalEventData.mapMarker ||*/ {};
                Object.keys(mapMarker)
                    /**
                     * jedes event darf nur noch auf einem plan einen marker haben
                     */
                    .filter((k) => +k === this.plansComponent?.planForm.value?.documentId)
                    .forEach((k) => {
                        m[+k] = mapMarker[+k].map((m) => ({
                            top: m.top,
                            left: m.left,
                        }));
                    });

                additionalEventData.mapMarker = m;

                const materialDevices = this.DialogFormGroup.value.MaterialDevices;
                const filteredDevices = materialDevices.filter((device) => device.name !== null);

                this.store.dispatch(
                    EventsActionTypes.ModifyEvent({
                        Payload: {
                            id: this.Data.eventId,
                            name: this.DialogFormGroup.value.eventName,
                            description: this.DialogFormGroup.value.eventText,
                            eventDate: FrontendDate(this.DialogFormGroup.value.date?.toDate(), true),
                            additionalData: JSON.stringify(additionalEventData),
                            state: this.DialogFormGroup.value.state,
                            executingCompany: this.DialogFormGroup.value.executingCompany,
                            materialDeviceAsString: JSON.stringify(filteredDevices),
                            automaticEventNumber: this.DialogFormGroup.value.automaticEventNumber,
                            eventNumber: this.DialogFormGroup.value.eventNumber,
                        },
                    }),
                );

                if (this.categoryIdsRemoved.length > 0 || this.categoryIdsAdded.length > 0) {
                    this.categoryIdsRemoved.forEach((categoryId) => {
                        const e2c = this.Data.categories.Event2EventCategories.filter((value) => value.EventId === this.Data.eventId && value.CategoryId === categoryId);
                        if (e2c != null && e2c.length > 0) {
                            this.eventCategoriesDataService.deleteEvent2EventCategory({
                                Id: e2c[0].Id.toString(),
                            });
                        }
                    });

                    this.categoryIdsAdded.forEach((categoryId) => {
                        this.eventCategoriesDataService.addEvent2EventCategory({
                            EventId: this.Data.eventId.toString(),
                            CategoryId: categoryId.toString(),
                        });
                    });
                }
            });

        this.actions$.pipe(ofType(EventsActionTypes.UpdateEvent), take(1)).subscribe((action) => {
            this.LS.isLoading = false;
            if (multiple) {
                this.SaveNewUserToEvent(true);
                this.subs.forEach((s) => s.unsubscribe());
                this.subs = [];
                this.DialogFormGroup.markAsPristine();
                this.Data.eventId = undefined;
                this.SaveNextEvent = true;
                this.Data.newEvent = true;
                this.SaveNewUserToEvent(true);
                this.ngOnInit(u2esTabeledata).finally(() => (this.SavingNext = false));

            } else {
                this.SaveNewUserToEvent(true);
                this.dialogRef.close('save');
            }
        });
    }

    public SaveNewUserToEvent(preventLoading = false) {
        if (this.NewUserToEventFormGroup.valid) {
            if (!preventLoading) {
                this.LS.isLoading = true;
            }
            this.actions$.pipe(ofType(UserToEventActionTypes.UpdateOne, BaseActionTypes.ErrorAction), take(1)).subscribe((action) => {
                if (action.type === UserToEventActionTypes.UpdateOne.type) {
                    this.NewUserToEventFormGroup.reset();
                }
                if (!preventLoading) {
                    this.LS.isLoading = false;
                }
            });
            const additionalData: UserToEventEntityAdditionalData = {
                timespan: this.NewUserToEventFormGroup.value.time,
            };
            this.store.dispatch(
                UserToEventActionTypes.Create({
                    Payload: {
                        eventId: this.Data.eventId,
                        userId: this.NewUserToEventFormGroup.value.user.Id,
                        additionalData: JSON.stringify(additionalData),
                    },
                }),
            );
        }
    }

    public SaveChangeEventToUser(element: TableData) {
        this.LS.isLoading = true;
        this.actions$.pipe(ofType(UserToEventActionTypes.UpdateOne, BaseActionTypes.ErrorAction), take(1)).subscribe(() => {
            this.LS.isLoading = false;
        });
        const additionalData: UserToEventEntityAdditionalData = {
            ...element.u2e.AdditionalData,
            timespan: element.timeForm.value,
        };
        this.store.dispatch(
            UserToEventActionTypes.Change({
                Payload: { id: element.u2e.Id, additionalData: JSON.stringify(additionalData) },
            }),
        );
    }

    public DeleteEventToUser(id: number) {
        this.store.dispatch(UserToEventActionTypes.Delete({ Payload: { id } }));
    }

    public OpenFileUpload(CommissionId: number) {
        const files$ = this.Folder$.pipe(switchMap((folder) => (isNotNullOrUndefined(folder) ? this.fileDataService.GetFilesStateFromFolder$(folder?.Id) : of([] as FileEntity[]))));
        const folder$ = this.folderDataService.getFolderFromEntity(CommissionId, FolderTypes.commission);

        combineLatest([files$, folder$])
            .pipe(take(1))
            .subscribe(([files, folder]) => {
                if (this.fileDialog?.getState() === MatDialogState.OPEN) {
                    this.fileDialog.close();
                }
                this.fileDialog = this.dialog.open<DaveSelectFileFromDmsComponent, DaveSelectFileFromDmsComponentDialogData, DaveSelectFileFromDmsComponentReturnData>(DaveSelectFileFromDmsComponent, {
                    ...DaveSelectFileFromDmsComponent.DefaultConfig,
                    data: {
                        moveWarning: '',
                        preSelectedFiles: [...files.map((f) => f.Id)],
                        folderId: folder?.Id,
                    },
                });
                this.fileDialog
                    .afterClosed()
                    .pipe(
                        take(1),
                        switchMap(({ documents }) =>
                            this.folderDataService.getFolderFromEntity(this.Data.eventId, FolderTypes.event).pipe(
                                take(1),
                                withLatestFrom(this.store.select(getFiles)),
                                tap(([folder, allfiles]) => {
                                    if (documents) {
                                        const selectedFiles = allfiles.filter((f) => documents.includes(f.Id));
                                        const filesToSet = selectedFiles.filter((f) => !f.EventIds?.includes(f.Id));
                                        const filesToUnSet = files.filter((f) => !documents.includes(f.Id));
                                        const folderId = folder?.Id;
                                        if (folderId) {
                                            filesToSet.forEach((f) => {
                                                this.store.dispatch(
                                                    // FilesActionTypes.ModifyFileRequest({
                                                    //     Payload: {
                                                    //         DocumentId: f.Id.toString(),
                                                    //         FolderId: folderId?.toString(),
                                                    //         EventIds: [this.Data.eventId, ...f.EventIds].map(e => e.toString()),
                                                    //     },
                                                    // }),
                                                    FilesActionTypes.CreateLinkRequest({
                                                        Payload: {
                                                            DocumentId: f.Id.toString(),
                                                            EventId: this.Data.eventId.toString(),
                                                            FolderId: folderId?.toString(),
                                                        },
                                                    }),
                                                );
                                            });
                                        } else {
                                            filesToSet.forEach((f) => {
                                                this.store.dispatch(
                                                    FilesActionTypes.ModifyFileRequest({
                                                        Payload: {
                                                            DocumentId: f.Id.toString(),
                                                            AutoSetFolder: true,
                                                            EventIds: [this.Data.eventId, ...f.EventIds].map((e) => e.toString()),
                                                        },
                                                    }),
                                                );
                                            });
                                        }
                                        filesToUnSet.forEach((f) => {
                                            this.store.dispatch(
                                                FilesActionTypes.ModifyFileRequest({
                                                    Payload: {
                                                        DocumentId: f.Id.toString(),
                                                        EventIds: f.EventIds.filter((id) => id !== this.Data.eventId).map((e) => e.toString()),
                                                    },
                                                }),
                                            );
                                        });
                                    }
                                }),
                            ),
                        ),
                    )
                    .subscribe();
            });
    }

    @ViewChild('fileInput') fileInput!: ElementRef;
    triggerFileInput(): void {
        this.fileInput.nativeElement.click();
    }

    public OnUploadError([file, message]) {
        console.error({ file, message });
        if (file.previewElement) {
            this.removeProgressClass(file.previewElement);
        }
    }

    private pollFiles() {
        this.Folder$.pipe(take(1)).subscribe((folder) => {
            const folderId = folder?.Id;
            console.log({ folderId });
            if (folderId) {
                this.store.dispatch(
                    FilesActionTypes.LoadFilesFromFolder({
                        Payload: folderId,
                    }),
                );
            } else {
                this.store.dispatch(
                    FilesActionTypes.LoadFilesAfter({
                        Payload: 10,
                    }),
                );
            }
        });
    }
    public QueComplete() {
        this.pollFiles();
    }

    public OnSelect(event) {
        this.fileUploadUIds.push(event.upload.uuid);
    }

    public OnRemove(event) {
        this.fileUploadUIds.splice(this.fileUploadUIds.indexOf(event.upload.uuid), 1);
    }

    removeProgressClass(previewElement: Element) {
        for (let node of previewElement.querySelectorAll('[data-dz-uploadprogress].indeterminate-progress')) {
            node.classList.remove('indeterminate-progress');
        }
    }
    addProgressClass(previewElement: Element) {
        for (let node of previewElement.querySelectorAll('[data-dz-uploadprogress]')) {
            node.classList.add('indeterminate-progress');
        }
    }

    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];

            //  this.OnSelect({ file });
            this.uploadFile(file);
        }
    }

    uploadFile(file: File) {
        const dropzone = this.dropzoneComponent.directiveRef.dropzone();
        dropzone.addFile(file);
    }

    onDropzoneSuccess([file]) {
        if (file.previewElement) {
            this.removeProgressClass(file.previewElement);
        }
    }

    onDropzoneUploadProgress([file, progress, bytesSent]) {
        if (progress === 100 && file.previewElement) {
            this.addProgressClass(file.previewElement);
        }
    }

    onMapMarkerChange($event: MapMarkerFileDictionary) {
        console.log('onMapMarkerChange', $event);
        this.DialogFormGroup.controls.mapMarker.setValue($event);
        this.DialogFormGroup.controls.mapMarker.markAsDirty();
    }
    async onScreenshotTaken(file: Blob) {
        const uploadParams = await firstValueFrom(this.fileUploadParams$);
        const clonedMap = new Map(uploadParams);
        clonedMap.set('name', PLAN_FILE_PREFIX_FOR_SFDT_TEMPLATES + '-' + uploadParams.get('event_id') + '-' + moment().format('DD-MM-YYYY'));
        this.store.dispatch(
            FilesActionTypes.UploadFileBackendRequest({
                Payload: {
                    file: file,
                    params: clonedMap,
                },
            }),
        );
        const action = await firstValueFrom(this.actions$.pipe(ofType(FilesActionTypes.UploadFileBackendFailure, FilesActionTypes.UploadFileBackendSuccess)));
        if (action.type === FilesActionTypes.UploadFileBackendSuccess.type) {
            this.pollFiles();
            this.toastrService.success(action.Payload.Name + ' erfolgreich gespeichert', 'Screenshot gespeichert');
        } else {
            this.store.dispatch(BaseActionTypes.ErrorAction({ Payload: { ToasterMessage: 'Screenshot speichern fehlgeschlagen' } }));
        }
    }

    async onAddAssignedPersons() {
        const persons = await firstValueFrom(this.assignedPersons$);
        const personIds = persons.map((p) => p.Id);
        this.dialog
            .open<SelectPersonsComponent, SelectPersonsComponentDialogData, SelectPersonsComponentDialogReturnData>(SelectPersonsComponent, {
                ...SelectPersonsComponent.DefaultConfig,
                data: {
                    // ButtonText: 'test',
                    SelectedPersonIds: [],
                    personFilter: (p) => personIds.includes(p.Id) && !p.Deleted,
                },
            })
            .afterClosed()
            .subscribe((ret) => {
                if (ret?.length) {
                    this.DialogFormGroup.controls.executingCompany.setValue([this.DialogFormGroup.value.executingCompany, ...ret.map((p) => p.DisplayName)].filter((v) => !!v).join(', '));
                }
            });
    }

    get Categories(): EventCategoriesEntity[] {
        return this.DialogFormGroup.controls.Categories.value || [];
    }

    protected readonly EventTypeNamesEnum = EventTypeNamesEnum;

    ngAfterViewInit(): void {
        this.afterViewInit$.next(true);
    }

    onCategoriesChanged(newcategories: EventCategoriesEntity[] | null) {
        const oldCategories = this.previousCategories || [];
        const newList = newcategories || [];

        const added = newList.filter((cat) => !oldCategories.some((oldCat) => oldCat.Id === cat.Id));
        const removed = oldCategories.filter((cat) => !newList.some((newCat) => newCat.Id === cat.Id));

        if (added.length > 0) {
            this.categoryIdsAdded.push(added[0].Id);
            this.categoryIdsRemoved = this.categoryIdsRemoved.filter((id) => id !== added[0]?.Id);
        }

        if (removed.length > 0) {
            this.categoryIdsRemoved.push(removed[0].Id);
            this.categoryIdsAdded = this.categoryIdsAdded.filter((id) => id !== added[0]?.Id);
        }
    }

    Cancel() {
        if (this.Data.newEvent) {
            this.store.dispatch(EventsActionTypes.DeleteEvent({ Payload: this.Data.eventId }));
            this.dialogRef.close('abort');
        } else {
            this.dialogRef.close('abort');
        }
    }
}
